<template lang="pug">
  main
    NavBarDocumentacion
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Documentación&nbsp
              a.button.is-black.is-rounded(@click='backPage')
                i.fas.fa-times
        .columns.is-multiline
          .column.is-3(v-show="verManuales")
            .card
              .card-content.has-text-dark
                div.card_title
                  p.has-text-weight-medium.is-size-5 Inventario
                div.card_item
                  a.button.is-small.is-black.is-rounded(@click="descargar('inv_m')")
                    | Manual&nbsp
                    i.fas.fa-file-word
                div.card_item
                  a.button.is-small.is-danger.is-rounded(@click="descargar('inv_d')") 
                    | Diagrama de flujo&nbsp
                    i.fas.fa-file-pdf
          .column.is-3(v-show="!verManuales")
            .card
              .card-content.has-text-dark
                div.card_title
                  p.has-text-weight-medium.is-size-5 Tickets Usuarios
                div.card_item
                  a.button.is-small.is-black.is-rounded(@click="descargar('tick_mU')")
                    | Manual&nbsp
                    i.fas.fa-file-word
          .column.is-3(v-show="verManuales")
            .card
              .card-content.has-text-dark
                div.card_title
                  p.has-text-weight-medium.is-size-5 Combustible
                div.card_item
                  a.button.is-small.is-black.is-rounded(@click="descargar('comb_t')")
                    | Manual&nbsp
                    i.fas.fa-file-word
                div.card_item
                  a.button.is-small.is-danger.is-rounded(@click="descargar('comb_d')") 
                    | Diagrama de flujo&nbsp
                    i.fas.fa-file-pdf
          .column.is-3(v-show="verManuales")
            .card
              .card-content.has-text-dark
                div.card_title
                  p.has-text-weight-medium.is-size-5 Requisiciones
                div.card_item
                  a.button.is-small.is-black.is-rounded(@click="descargar('req_m')")
                    | Manual&nbsp
                    i.fas.fa-file-word
                div.card_item
                  a.button.is-small.is-danger.is-rounded(@click="descargar('req_d')")
                    | Diagrama de flujo&nbsp
                    i.fas.fa-file-pdf
          .column.is-3(v-show="verManuales")
            .card
              .card-content.has-text-dark
                div.card_title
                  p.has-text-weight-medium.is-size-5 Responsivas
                div.card_item
                  a.button.is-small.is-black.is-rounded(@click="descargar('resp_m')")
                    | Manual&nbsp
                    i.fas.fa-file-word
                div.card_item
                  a.button.is-small.is-danger.is-rounded(@click="descargar('resp_d')")
                    | Diagrama de flujo&nbsp
                    i.fas.fa-file-pdf
          .column.is-3(v-show="verManuales")
            .card
              .card-content.has-text-dark
                div.card_title
                  p.has-text-weight-medium.is-size-5 Proceso Ticket/Solicitudes - Reportes
                div.card_item
                  a.button.is-small.is-black.is-rounded(@click="descargar('proceso_m')")
                    | Manual&nbsp
                    i.fas.fa-file-word
                div.card_item
                  a.button.is-small.is-danger.is-rounded(@click="descargar('proceso_d')")
                    | Diagrama de flujo&nbsp
                    i.fas.fa-file-pdf
        .columns.column-blanco
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarDocumentacion from './layout/NavBar_documentacion.vue'

  import { mapState } from 'vuex'

  export default {
    name: 'HomeDocumentacion',
    components: { NavBarDocumentacion, Loader },
    data() {
      return {
        isLoading: true,
        verManuales: true
      }
    },
    methods: {
      iniciarComponente() {
        setTimeout(() => {
          this.isLoading = false
        }, 100)
      },
      descargar (option) {
        let file
        const currentURL = window.location.hostname
        switch (option) {
          case 'inv_m':
            file = `https://${currentUrl}/assets/documentacion/Inventarios.docx`  
            break
          case 'inv_d':
            file = `https://${currentUrl}/assets/documentacion/d_Inventarios.pdf`  
            break
          case 'tick_mU':
            file = `https://${currentUrl}/assets/documentacion/Tickets.docx`  
            break
          case 'comb_t':
            file = `https://${currentUrl}/assets/documentacion/Combustible.docx`  
            break
          case 'comb_d':
            file = `https://${currentUrl}/assets/documentacion/d_Combustible.pdf`  
            break
          case 'req_m':
            file = `https://${currentUrl}/assets/documentacion/Requisiciones.docx`  
            break
          case 'req_d':
            file = `https://${currentUrl}/assets/documentacion/d_Requisiciones.pdf`  
            break
          case 'resp_m':
            file = `https://${currentUrl}/assets/documentacion/Responsivas.docx`  
            break
          case 'resp_d':
            file = `https://${currentUrl}/assets/documentacion/d_Responsivas.pdf`  
            break
          case 'proceso_m':
            file = `https://${currentUrl}/assets/documentacion/Soporte.docx`  
            break
          case 'proceso_d':
            file = `https://${currentUrl}/assets/documentacion/d_Soporte.pdf`
            break
        }

        open(file, '_black', 'norefere noopener')
      },
      backPage () {
        this.$router.back()
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin'])
    }
  }
</script>

<style lang="scss" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
  .card_title {
    margin-bottom: 5px;
  }
  .card_item {
    margin-bottom: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/documentacion_Componentes/Home_documentacion.vue